import getJSON from './get-json';

const LOOKUP_URL = ({ latitude, longitude, includeGeography = false }) =>
  `https://dv-dev.texastribune.org/legislative-lookup-2025/?latitude=${latitude}&longitude=${longitude}`;

export function lookup({ latitude, longitude }) {
  return getJSON(LOOKUP_URL({ latitude, longitude }));
}